import { useEffect, useRef, useState } from "react";

export default function SignaturePad({ onChange }) {
  const ref = useRef();
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);
  useEffect(() => {
    const c = ref.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = c.offsetHeight * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.strokeStyle = "#0F172A";
  }, []);
  const pos = (e) => {
    const r = ref.current.getBoundingClientRect();
    return [e.clientX - r.left, e.clientY - r.top];
  };
  const down = (e) => {
    e.preventDefault();
    ref.current.setPointerCapture(e.pointerId);
    drawing.current = true;
    const ctx = ref.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = ref.current.getContext("2d");
    ctx.lineTo(...pos(e));
    ctx.stroke();
  };
  const up = () => {
    if (!drawing.current) return;
    drawing.current = false;
    setEmpty(false);
    onChange(ref.current.toDataURL("image/png"));
  };
  const clear = () => {
    const c = ref.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange("");
  };
  return (
    <div>
      <canvas ref={ref} className="w-full h-44 bg-white border-2 border-dashed border-slate-300 rounded-xl touch-none" onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} data-testid="signature-canvas" />
      <div className="flex justify-between mt-1 text-xs text-slate-500">
        <span>{empty ? "✍" : ""}</span>
        <button type="button" onClick={clear} className="underline min-h-[32px]" data-testid="signature-clear-btn">Clear / Borrar</button>
      </div>
    </div>
  );
}
